import apiService from "./../../../../server";
import { TASK, TASK_COMMENT, TASK_DATA, TASK_FILES, TASK_STATUS, TASK_UPDATE, TASKS, TASKS_BOARD } from "../api";

export function fetchAllTasks(page,size,filters) {
    return apiService.get(TASKS,{params:{"page":page, "size":size,"priority":filters.priority,"status":filters.status,"category":filters.category,"state":filters.state}});
}
export function fetchAllTasksBoard(filters) {
    return apiService.get(TASKS_BOARD,{params:{"priority":filters.priority,"status":filters.status,"category":filters.category,
        "fromDate":filters.fromDate,"toDate":filters.toDate,"dueDate":filters.dueDate,"state":filters.state
    }});
}
export function getTaskData() {
    return apiService.get(TASK_DATA);
}
export function getTask(taskId) {
    return apiService.get(TASK,{params:{"taskId":taskId}});
}
export function saveTask(task) {
    return apiService.post(TASK,task,{headers:{
        'Content-Type': 'multipart/form-data',
    }});
}
export function updateTask(task) {
    return apiService.put(TASK_UPDATE,task);
}
export function addComment(task) {
    return apiService.put(TASK_COMMENT,task);
}
export function updateFile(task) {
    return apiService.put(TASK_FILES,task,{headers:{
        'Content-Type': 'multipart/form-data',
    }});
}
export function updateStatus(task) {
    return apiService.put(TASK_STATUS,task);
}
